import { render, staticRenderFns } from "./ConsultasOdontologicas.vue?vue&type=template&id=e74df97a"
import script from "./ConsultasOdontologicas.vue?vue&type=script&lang=js"
export * from "./ConsultasOdontologicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports